module.exports = __webpack_public_path__ + "static/media/shishu.e6946be9.ogg";